import React, { Component } from "react";
import { connect } from "react-redux";
import SignalRService from "../../_services/signalRService";
import userActions from "../../_actions/userActions";
import { projSelectorConstants } from "../../_constants/projSelectorConstants";
import { ADR, ADR_REVIEW, APP_WARNING, ERROR } from "../../_constants/actionConstants";
import { DOCTYPE } from "../../_constants/docTypeConstants";
import { modalTabIds } from "../../_constants/modalTabIds";
import { faIconImports } from "../../_helpers/faIconImports";
import feederListActions from "../../_actions/feederListActions";
import { updateProjDashWidget } from "../../_actions/dashActions";
import {
  buildMainMenu_transpoEngineer,
  buildMainMenu_manager,
  buildMainMenu_officeAssociate,
  buildMainMenu_supReSr,
} from "../../_actions/mainMenuActions";
import signalRActions from "../../_actions/signalRActions";
import Home from "../home/home";
import Search from "../search/search";
import Layout from "../Layout";
import ProjAdmin from "../projects/projAdmin/ProjAdmin";
import LinkContainer from "../linkContainer/linkContainer";
import ReportSelection from "../reportSelection/ReportSelection";
import LaborWeeklyReport from "../reports/laborWeeklyReport";
import ContractorWeeklyReport from "../reports/contractorWeeklyReport";
import ItemEstimateQuantitiesReport from "../reports/itemEstimateQuantitiesReport";
import CommentKeywordReport from "../reports/commentKeywordReport";
import ProjAssignment from "../projects/projAssignment/projAssignment";
import projActions from "../../_actions/projActions";
import ProjList from "../projects/projList/projList";
import AdrList from "../AdrList/adrList";
import AdrMainV3 from "../AdrV3/AdrMainV3";
import ProjDash from "../projects/projDash/projDash";
import IssueTracker from "../issueTracker/IssueTracker";
import NotifCenter from "../notifCenter/notifCenter";
import AdminMain from "../AdminTasks/AdminMain";
import About from "../about/About";
import Overtime from "../overtime/Overtime";
import IssueThread from "../issueTracker/IssueThread";
import WorkPerformedReport from "../reports/WorkPerformedReport";
import UserPreferences from "../userPreferences/UserPreferences";
import AdrSearchModal from "../adrSearch/adrSearchModal";
import LoginModal from "../login/loginModal";
import AlertModal from "../_common/AlertModal";
import ErrorAlert from "../_common/ErrorAlert";
import EditUserModal from "../AdminTasks/AdminUsers/EditUserModal";
import toast, { Toaster } from "react-hot-toast";
import "./styles/nav.css";
import cem4601PdfActions from "../../_actions/cem4601PdfActions";
import CmtList from "../qms/cmt/CmtList";
import QmsAdmin from "../qms/admin/QmsAdmin";
import CmtIssue from "../qms/cmt/CmtIssue";
import QmsDashboard from "../qms/dashboard/QmsDashboard";
import adrActions from "../../_actions/adrActions";
import WarningAlert from "../_common/WarningAlert";
import DATA_TO_REFRESH from "../../_constants/dataToRefresh";
import contractorActions from "../../_actions/contractorActions";
import laborActions from "../../_actions/laborActions";
import laborCrewActions from "../../_actions/laborCrewActions";
import equipmentActions from "../../_actions/equipmentActions";
import bidItemActions from "../../_actions/bidItemActions";
import ccoActions from "../../_actions/ccoActions";
import keywordActions from "../../_actions/keywordActions";
import locationActions from "../../_actions/locationActions";
import pendingIssueActions from "../../_actions/pendingIssueActions";
import PATCH_REQUEST_TYPE from "../../_constants/patchRequestTypes";
import { actionScripts } from "../../_helpers/actionScripts";
import UserPreferencesV2 from "../userPreferences/UserPreferencesV2";
import PDF_REQUEST_TYPES from "../../_constants/pdfRequestTypes";
import authenticationActions from "../../_actions/authenticationActions";
import EditUserDetailsModal from "../AdminTasks/AdminUsers/EditUserDetailsModal";

class MainSwitch extends Component {
  constructor(props) {
    super(props);

    this.dmsSignalRService = new SignalRService();

    this.state = {
      showLoginModal: false,
      showRegisterUserModal: false,
      showAdrSearchModal: false,
      showReportSelectionModal: false,
      showProjAssignmentProjSelectionModal: false,
      showAlert_logoutConfirm: false,
      showAlert_unauthorized: false,
      adrSearchInitProjectId: 0,
      adrSearchShowProjectsFor: "",
      adrSearchTabId: null,
    };
  }

  /////////////////////////////////////////////////////////////////////////////
  /// SignalR
  /////////////////////////////////////////////////////////////////////////////
  configureSignalR = () => {
    const { dispatch } = this.props;
    const { user } = this.props.authentication;

    this.dmsSignalRService.configureConnection();

    this.dmsSignalRService.receiveNotification((newNotification) =>
      dispatch(signalRActions.addNotificationAction(newNotification))
    );

    this.dmsSignalRService.receivePatchRequest((payload) => {
      // Review revoke is sent in response to transfer of a review from
      // one reviewer to another, and it notifies the original reviewer that
      // their review has been transferred away from them, and that they can
      // no longer approve/reject (but can still add correction comments.)
      if (payload.patchRequestType === PATCH_REQUEST_TYPE.START_DAILY_REPORT_REVIEW) {
        const revokeReview = payload.revokedReviewerUserId === user.userId;
        actionScripts.UPDATE_ADR_REVIEW_STARTED.run(
          payload.assistantDailyReportId,
          payload.newReviewerUserId,
          payload.newReviewStartedOn,
          revokeReview
        );
      }

      if (payload.patchRequestType === PATCH_REQUEST_TYPE.DAILY_REPORT_STATUS_UPDATE) {
        actionScripts.UPDATE_ADR_STATUS.run(
          payload.status.assistantDailyReportId,
          payload.status
        );
      }
    });

    this.dmsSignalRService.receiveProjDataRefresh((payload) => {
      dispatch(feederListActions.getAllStatic());
      const _dataToRefresh = payload.dataToRefresh || [];
      if (_dataToRefresh.includes(DATA_TO_REFRESH.all))
        dispatch(feederListActions.getAll(payload.projectId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.projContractorList))
        dispatch(contractorActions.getAllForProject(payload.projectId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.projLaborList))
        dispatch(laborActions.updateAll(payload.projectId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.projLaborCrewList))
        dispatch(laborCrewActions.getAll(payload.projectId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.projEquipList))
        dispatch(equipmentActions.getAll(payload.projectId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.projItemList))
        dispatch(bidItemActions.getAll(payload.projectId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.projCcoList))
        dispatch(ccoActions.getAll(payload.projectId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.projKeywordList))
        dispatch(keywordActions.getAll(payload.projectId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.projLocationList))
        dispatch(locationActions.getAll(payload.projectId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.projPendingIssueList))
        dispatch(pendingIssueActions.getAll(payload.projectId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.projStaffList))
        dispatch(projActions.fetchAllStaff(payload.projectId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.projUnitList))
        dispatch(projActions.fetchProjectUnits(payload.projectId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.dailyReportList))
        dispatch(adrActions.updateAdrList(payload.projectId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.dailyReport))
        actionScripts.REFETCH_ADR_IN_TAB_AUTO.run(payload.assistantDailyReportId);

      if (_dataToRefresh.includes(DATA_TO_REFRESH.dailyReportCorrectionComments))
        dispatch(adrActions.fetchCorrectionComments(payload.assistantDailyReportId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.dailyReportClarificationComments))
        dispatch(adrActions.fetchClarificationComments(payload.assistantDailyReportId));

      if (_dataToRefresh.includes(DATA_TO_REFRESH.userList))
        dispatch(userActions.refreshExistingChunk());
    });

    this.dmsSignalRService.receiveProjDashRefresh((payload) => {
      dispatch(updateProjDashWidget(payload.widgetType, payload.projectId));
    });

    this.dmsSignalRService.receiveProjAssignmentRefresh((payload) =>
      dispatch(projActions.fetchAllStaff(payload.projectId))
    );

    this.dmsSignalRService.receiveUserProjectRolesRefresh((payload) =>
      dispatch(userActions.getProjectRoles(payload.userId))
    );

    this.dmsSignalRService.receivePdfRequest((payload) => {
      switch (payload.pdfRequestType) {
        case PDF_REQUEST_TYPES.cem4601AdHoc:
          break;
        case PDF_REQUEST_TYPES.cem4601Submit:
          dispatch(cem4601PdfActions.createPdfForSubmit(payload.assistantDailyReportId));
          break;
        case PDF_REQUEST_TYPES.cem4601Approve:
          dispatch(cem4601PdfActions.signPdfForApproval(payload.assistantDailyReportId));
          break;
        default:
          break;
      }
    });

    this.dmsSignalRService.backgroundTaskToast_init((payload) => {
      const toastId = toast.loading(payload.message);
      localStorage.setItem(payload.processId, toastId);
    });

    this.dmsSignalRService.backgroundTaskToast_progress((payload) => {
      const toastId = localStorage.getItem(payload.processId);
      toast.loading(payload.message, { id: toastId });
    });

    this.dmsSignalRService.backgroundTaskToast_success((payload) => {
      const toastId = localStorage.getItem(payload.processId);
      toast.success(payload.message, { id: toastId });
      if (payload.type === "Cem4601Batch")
        dispatch(cem4601PdfActions.downloadZipFile(payload.miscPayload));
      if (payload.type === "DailyReportPhotos")
        dispatch(adrActions.downloadZipFile(payload.miscPayload));
      localStorage.removeItem(payload.processId);
    });

    this.dmsSignalRService.backgroundTaskToast_fail((payload) => {
      const toastId = localStorage.getItem(payload.processId);
      toast.error(payload.message, { id: toastId });
      localStorage.removeItem(payload.processId);
    });
  };

  reconnectSignalR = () => this.dmsSignalRService.reconnect();

  /////////////////////////////////////////////////////////////////////////////
  /// MainSwitch Component-Level Stuff
  ///
  /////////////////////////////////////////////////////////////////////////////
  async componentDidMount() {
    const { dispatch } = this.props;
    faIconImports();
    await dispatch(userActions.getAppSettings());
    await dispatch(userActions.getAuth());

    // userId/employeeNo entries in localStorage are only for native app use.
    // They are picked up after auth, so remove them (30s matches db timeout)
    setTimeout(() => {
      localStorage.removeItem("userId");
      localStorage.removeItem("employeeNo");
    }, 30000);

    if (this.props.authentication.loggedIn) this.initSession();
  }

  /**
   * Initializes an authenticated ProDMS session.
   * Includes any startup operations, such as preparing SignalR, the main menu,
   * and preloading some commonly used lookup tables (e.g. UserRoles).
   */
  initSession = () => {
    const { dispatch } = this.props;
    const { user } = this.props.authentication;

    this.configureSignalR();
    this.dmsSignalRService.start();

    dispatch(userActions.getUserRoles());

    // Fetch static lookup lists for project use (locationTypes, trades, etc.)
    dispatch(feederListActions.getAllStatic());

    dispatch(userActions.getNotifications(user.userId));

    if (user.isOfficeAdmin) dispatch(buildMainMenu_officeAssociate());
    else {
      const filters = {
        projectId: null,
        district: null,
        unitId: null,
        userId: user.userId,
        EA: "",
        proDMSProjectsOnly: true,
      };
      // TE (A-D)
      if (user.userRole.userRoleClass === "TE")
        dispatch(projActions.fetchAllByFilter(filters)).then((projects) => {
          if (projects && projects.length > 0)
            dispatch(buildMainMenu_transpoEngineer(projects));
        });
      // Senior or above
      else if (["SENTEBE", "SUPTEBE"].includes(user.userRole.userRoleClass))
        dispatch(projActions.fetchAllByFilter(filters)).then((asProjs) => {
          const isSupReSr = asProjs.some((p) => p.projectRoleClass === "CEBCERESR");
          if (isSupReSr) dispatch(buildMainMenu_supReSr());
          dispatch(buildMainMenu_manager());
        });
    }

    if (user.mustRegister) this.setState({ showRegisterUserModal: true });
    if (user && user.username) {
      dispatch(projActions.fetchAllByFilter({}, 0));
      dispatch(projActions.fetchProjectRoles());
    }
  };

  getContent = (tab) => {
    const { fetching } = this.props;
    switch (tab.docType) {
      case "SEARCH":
        return <Search key={`searchKey_${tab.tabId}`} tab={tab} />;
      case DOCTYPE.LINK:
        return (
          <LinkContainer
            key={`linkContainerKey_${tab.tabId}`}
            tab={tab}
            content={tab.link}
          />
        );
      case DOCTYPE.ADMIN_TASKS:
        return <AdminMain tab={tab} />;
      case DOCTYPE.ADR:
        return <AdrMainV3 key={`adrKey_${tab.tabId}`} tab={tab} />;
      case DOCTYPE.ADR_LIST:
        return (
          <AdrList
            key={`adrListKey_${tab.tabId}`}
            tab={tab}
            isSearchResult={false}
            toggleAdrSearchModal={this.toggleAdrSearchModal}
            fetching={fetching}
          />
        );
      case DOCTYPE.ADR_SEARCH_RESULTS:
        // TODO: provide null check of adrSearchResultsList, and undefined check
        //       for the find operation (also whether tab.searchId is null or not).
        return (
          <AdrList
            key={`adrListKey_${tab.tabId}`}
            tab={tab}
            isSearchResult={true}
            toggleAdrSearchModal={this.toggleAdrSearchModal}
          />
        );
      case DOCTYPE.REPORT_SELECTION:
        return <ReportSelection key={`reportSelectionKey_${tab.tabId}`} tab={tab} />;
      case DOCTYPE.REPORT_LABOR_WEEKLY:
        return <LaborWeeklyReport key={`lwReportKey_${tab.tabId}`} tab={tab} />;
      case DOCTYPE.REPORT_CONTRACTOR_WEEKLY:
        return <ContractorWeeklyReport key={`cwReportKey_${tab.tabId}`} tab={tab} />;
      case DOCTYPE.REPORT_WORK_PERFORMED:
        return <WorkPerformedReport key={`wpReportKey_${tab.tabId}`} tab={tab} />;
      case DOCTYPE.REPORT_ITEM_EST_QUANTITIES:
        return (
          <ItemEstimateQuantitiesReport key={`ieqReportKey_${tab.tabId}`} tab={tab} />
        );
      case DOCTYPE.REPORT_COMMENT_KEYWORD:
        return <CommentKeywordReport key={`ckReportKey_${tab.tabId}`} tab={tab} />;
      case DOCTYPE.PROJECT_LIST:
        return <ProjList key={`projListKey_${tab.tabId}`} tab={tab} />;
      case DOCTYPE.PROJECT_SETUP:
        return (
          <ProjAdmin
            key={`projSetupKey_${tab.tabId}`}
            tabId={tab.tabId}
            projectId={tab.projectId}
          />
        );
      case DOCTYPE.PROJECT_DASH:
        return <ProjDash projectId={tab.projectId} tabId={tab.tabId} />;
      case DOCTYPE.PROJECT_ASSIGNMENT:
        // projStaffList in feederLists maps to IList<ProjectUserDto>
        return <ProjAssignment tab={tab} />;
      case DOCTYPE.OVERTIME_LIST:
        return <Overtime tabId={tab.tabId} />;
      case DOCTYPE.NOTIF_CENTER:
        return <NotifCenter />;
      case DOCTYPE.ISSUE_TRACKER:
        return <IssueTracker />;
      case DOCTYPE.ISSUE_THREAD:
        return <IssueThread tabId={tab.tabId} />;
      case DOCTYPE.USER_PREFERENCES:
        return <UserPreferencesV2 tabId={tab.tabId} />;
      case DOCTYPE.QMS_DASHBOARD:
        return <QmsDashboard tabId={tab.tabId} />;
      case DOCTYPE.QMS_ADMIN:
        return <QmsAdmin tabId={tab.tabId} />;
      case DOCTYPE.QMS_CHANGE_MANAGEMENT_TRACKER:
        return <CmtIssue tab={tab} />;
      case DOCTYPE.QMS_CHANGE_MANAGEMENT_TRACKER_LIST:
        return <CmtList tab={tab} />;
      case DOCTYPE.ABOUT:
        return <About />;
      default:
        return (
          <Home
            toggleLoginModal={this.toggleLoginModal}
            initSession={this.initSession}
            toggleAlert_logoutConfirm={this.toggleAlert_logoutConfirm}
          />
        );
    }
  };

  handleAlert_error = (actionType, errorId) => (e) => {
    e.preventDefault();
    if (actionType === "accept" && errorId)
      this.props.dispatch({ type: ERROR.ACKNOWLEDGE_ERROR, errorId });
  };

  handleAlert_warning = () => {
    const { dispatch, warningContext } = this.props;
    dispatch({
      type: APP_WARNING.ACKNOWLEDGE_WARNING,
      warningId: warningContext.warningId,
    });
  };

  /**
   * AdrSearchModal can be toggled from the main navbar or from another
   * module (e.g. AdrList).
   *
   * @param {number?} projectId - not provided when toggling on from main navbar
   * @param {Object} showProjectsFor - defaults to USER_ASSIGNED
   * @param {number} tabId
   */
  toggleAdrSearchModal =
    (projectId = 0, showProjectsFor, tabId = modalTabIds.ADR_SEARCH) =>
    () => {
      // Set the initProjectId when opening, and clear when closing (for next modal session).
      this.setState({
        adrSearchInitProjectId: !this.state.showAdrSearchModal ? projectId : 0,
        adrSearchShowProjectsFor: !this.state.showAdrSearchModal
          ? showProjectsFor || {
              type: projSelectorConstants.USER_ASSIGNED,
              lookupId: this.props.authentication.user.userId,
            }
          : null,
        showAdrSearchModal: !this.state.showAdrSearchModal,
        adrSearchTabId: tabId,
      });
    };

  toggleReportSelectionModal = () =>
    this.setState({
      showReportSelectionModal: !this.state.showReportSelectionModal,
    });

  toggleProjAssignmentProjSelectionModal = () => {
    this.setState({
      showProjAssignmentProjSelectionModal:
        !this.state.showProjAssignmentProjSelectionModal,
    });
  };

  toggleLoginModal = () => this.setState({ showLoginModal: !this.state.showLoginModal });

  toggleRegisterUserModal = (e) => {
    e && e.preventDefault();
    this.setState({ showRegisterUserModal: !this.state.showRegisterUserModal });
  };

  toggleAlert_logoutConfirm = () =>
    this.setState({
      showAlert_logoutConfirm: !this.state.showAlert_logoutConfirm,
    });

  toggleAlert_unauthorized = () =>
    this.setState({
      showAlert_unauthorized: !this.state.showAlert_unauthorized,
    });

  // Login button at Home jumbotron
  handleClick_login = (e) => {
    e.preventDefault();
    this.setState({ showLoginModal: true });
  };

  handleAlert_logoutConfirm = (actionType) => (e) => {
    e.preventDefault();
    if (actionType === "accept") {
      this.props.dispatch(userActions.logout());
      this.dmsSignalRService.stop();
    }
    this.toggleAlert_logoutConfirm();
  };

  render() {
    const {
      openTabs,
      authentication,
      selectedTabId,
      fetching,
      showAlert_error,
      showAlert_warning,
      errorContext,
      warningContext,
    } = this.props;
    const {
      showAdrSearchModal,
      adrSearchInitProjectId,
      adrSearchShowProjectsFor,
      adrSearchTabId,
      showReportSelectionModal,
      showRegisterUserModal,
      showLoginModal,
      showAlert_logoutConfirm,
    } = this.state;
    return (
      <React.Fragment>
        <Toaster />
        <Layout
          {...this.state}
          showAlert_error={showAlert_error}
          errorContext={errorContext}
          warningContext={warningContext}
          fetching={fetching}
          toggleLoginModal={this.toggleLoginModal}
          toggleAdrSearchModal={this.toggleAdrSearchModal}
          toggleReportSelectionModal={this.toggleReportSelectionModal}
          toggleProjAssignmentProjSelectionModal={
            this.toggleProjAssignmentProjSelectionModal
          }
          toggleAlert_logoutConfirm={this.toggleAlert_logoutConfirm}
          handleAlert_logoutConfirm={this.handleAlert_logoutConfirm}
        >
          {openTabs.map((tab) => (
            <div
              key={tab.tabId}
              className={`tab-pane border-secondary border-left-0 border-right-0 border-bottom-0 ${
                selectedTabId === tab.tabId ? "show active border" : ""
              }`}
              id={tab.tabId}
            >
              {this.getContent(tab)}
            </div>
          ))}
        </Layout>
        {showAdrSearchModal && (
          <AdrSearchModal
            showAdrSearchModal={showAdrSearchModal}
            toggleAdrSearchModal={this.toggleAdrSearchModal}
            initProjectId={+adrSearchInitProjectId} // projectId for pre-selection
            showProjectsFor={adrSearchShowProjectsFor}
            tabId={adrSearchTabId}
          />
        )}
        {showRegisterUserModal && (
          <EditUserDetailsModal
            showModal={showRegisterUserModal}
            toggleModal={this.toggleRegisterUserModal}
            tabId={null}
            user={authentication.user}
            isNewUserRegistration={true}
            allowRegisterAsOfficeAdmin={false}
          />
        )}
        {showLoginModal && (
          <LoginModal
            showLoginModal={showLoginModal}
            toggleLoginModal={this.toggleLoginModal}
            onSuccess={this.initSession}
          />
        )}
        {showAlert_logoutConfirm && (
          <AlertModal
            alertTitle={"Log Out"}
            alertTitleClass="bg-danger text-white"
            alertTitleIcon="times-circle"
            alertText={
              "Are you sure? All open tabs will be closed, and any unsaved data will be lost."
            }
            acceptCaption={"Log Out"}
            acceptClass={"danger"}
            provideReject={true}
            rejectCaption={"Cancel"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_logoutConfirm}
            showAlertModal={showAlert_logoutConfirm}
            toggleAlertModal={this.toggleAlert_logoutConfirm}
          />
        )}
        {showAlert_error && (
          <ErrorAlert
            errorContext={errorContext}
            handleAlertAction={this.handleAlert_error}
            showErrorAlert={showAlert_error}
            toggleErrorAlert={this.handleAlert_error}
          />
        )}
        {showAlert_warning && (
          <WarningAlert
            warning={warningContext}
            showAlert={showAlert_warning}
            toggleAlert={this.handleAlert_warning}
            handleAlertAction={this.handleAlert_warning}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const errorContext =
    state.errors.errors[(Object.keys(state.errors.errors || {}) || []).pop()];
  const warningContext =
    state.errors.warnings[(Object.keys(state.errors.warnings || {}) || []).pop()];
  return {
    errorContext,
    warningContext,
    showAlert_error: errorContext && !errorContext.isAcknowledged,
    showAlert_warning: warningContext && !warningContext.isAcknowledged,
    openTabs: state.mainTabs.openTabs,
    selectedTabId: state.mainTabs.selectedTabId,
    assignedProjectsForUser: state.projects.assignedProjectsForUser,
    authentication: state.authentication,
    fetching:
      state.adr.fetching ||
      state.users.fetching ||
      state.authentication.loggingIn ||
      state.feederLists.fetching ||
      state.bidItems.fetching ||
      state.ccos.fetching ||
      state.contractors.fetching ||
      state.locations.fetching ||
      state.labors.fetching ||
      state.laborCrews.fetching ||
      state.equipment.fetching ||
      state.keywords.fetching ||
      state.projects.fetching ||
      state.reports.fetching,
    fetchingCem4601Pdf: state.adr.fetchingPdf,
  };
};

export default connect(mapStateToProps)(MainSwitch);
